import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';

const Backward: FC<IIconsProps> = ({ color, size }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size || 16}
      height={size || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99776 7.73198L6.99699 7.73121L11.6678 3.06039L13 4.39253L9.66051 7.73199L12.9968 11.0682L11.6647 12.4004L6.99698 7.73276L6.99776 7.73198Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.01999 12.3396L6.01999 3.09961L4.12 3.09961L4.11999 12.3396L6.01999 12.3396Z"
        fill={color}
      />
    </svg>
  );
};

export default Backward;
